import { Component } from '@angular/core';

@Component({
  selector: 'uni-steps',
  templateUrl: './uni-steps.component.html',
  styleUrls: ['./uni-steps.component.scss'],
})
export class UniStepsComponent {}
